import React, { useState  } from "react";
import SelectorComponent from "./wallet/SelectorComponent";
import DisplayComponent from "./wallet/DisplayComponent";
import { useGetPaymentQuery } from "../apis/PaymentMethodApi";
  
const TopupWalletAmazon = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  
  // Fetch data from PaymentApi using the useGetPaymentQuery hook
  const { data: paymentData, isLoading, error } = useGetPaymentQuery();

  // This is a fallback or a mock of the wallet items in case the API call fails
  const items = paymentData ? paymentData : [
    {
      id: 1,
      name: " ",
      walletAdress: " ",
      imageUrl: " ",
    }, 
  ];

  const handleItemSelected = (item) => {
    setSelectedItem(item);
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading wallet Info</div>;
  }

  return (
    <section className="account py-15">
      <div className="container container-lg">
        <div className="row gy-4">
          {/* Pass the fetched items to the SelectorComponent */}
          <SelectorComponent items={items} onItemSelected={handleItemSelected} />
          {/* Display the selected item in DisplayComponent */}
          <DisplayComponent selectedItem={selectedItem} />
        </div>
      </div>
    </section>
  );
};

export default TopupWalletAmazon;
